var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", [
      _vm._v(
        "Please confirm that you want to update the order with this newly uploaded model"
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "sw-dms-button sw-dms-button--big",
        attrs: { title: "Cancel and re-upload" },
        on: { click: _vm.cancel }
      },
      [_vm._v("No, re-upload another model\n  ")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "sw-dms-button sw-dms-button--big sw-dms-button--red",
        attrs: { title: "Proceed with model" },
        on: { click: _vm.submit }
      },
      [_vm._v("Yes\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }